<template>
  <div :class="activateLoading ? 'abtg_loading-overlay ' : ''">
    <span class="abtg_loading-text" v-if="activateLoading">
      {{ $t("mapping.text_ricalcolo") }} &nbsp;
      <i class="fas fa-sync-alt loading fa-spin"></i>
    </span>

    <n-delete
        @closeModal="closeModal"
        @deleteResource="deleteResource"
    ></n-delete>
    <n-deletef
        @closeModal="closeModal"
        @deleteFolder="setFolderForDelete"
    ></n-deletef>
    <n-create
        @closeModal="closeModal"
        @createFolder="createFolder"
        v-bind:content="{meditFolder:editFolder, folderName:localfolderName}">
    </n-create>

    <n-modal-zone
        v-if="zoneInfo"
        v-bind:content="{ formData: zoneInfo }"
        @editZoneData="editZoneData"
        @closeModal="closeModal"
    ></n-modal-zone>
    <n-modal-building
        v-if="formData"
        v-bind:content="{ formData: formData, myError: myError }"
    ></n-modal-building>
    <n-range
        @rangeData="saveCustomRangeData"
        @deleteCustomRange="deleteCustomRange"
        @closeModal="closeModal"
        v-bind:content="{ customRange: customRange }"
    ></n-range>

    <n-bread v-bind:content="{ bread_list, bread_active }"></n-bread>

    <div
        v-if="lang ==='it'"
        class="row">
      <div class="mb-3 ml-3" style="background-color: rgba(204,204,204,0.4); padding: 10px;">Novità! Gestisci le zone in
        cartelle: Guarda il <a href="/tutorial" style="color:#ff5900; font-weight:bold;text-decoration: underline">video
          tutorial</a></div>
    </div>
    <div class="row">
      <div class="col-lg-3">
        <div class="form-group">

          <select
              class="form-control"
              v-model="selectedZone"
              @change="goToUrl('0')"
              id="exampleFormControlSelect1"
              style="font-size: 140%; font-weight: bold;height: 45px"

          >
            <option
                v-for="(r, index) in orderedRegionList"
                :value="{ cityId: r.city_id, city: r.city }"
            >
              {{ r.city }} ({{ r.zoneNumber }})
            </option>
          </select>

        </div>
      </div>
      <div class="col-lg-3">
        <div class="form-group">
          <select class="form-control" v-model="localfolderId" name="folder" id="folderId"
                  @change="goToUrl(localfolderId)" style="height: 45px">
            <option :value="0" @click="goToUrl('0')" class="font-weight-bold">
              {{ $t("mapping.first_folder") }}
            </option>
            <option v-for="folder in this.allFolder" :key="folder.id" :value="folder.id">
              {{ folder.name }}
            </option>


          </select>

        </div>
      </div>
      <div class="col-lg-3">

      </div>
      <div class="col-lg-3">
        <div
            class="abtg-all-zones" :class="activeAllZone">
          <a
              style="color:black"
              href="#"
              @click="allZoneByCity({ cityId: cityId, city: city })"
          >{{ $t("mapping.tutte_le_zone") }}</a>
        </div>
      </div>
    </div>


    <div class="row mx-2">


      <hr class="abtg__hr-folder">
      <div v-if="localfolderId>0">
        <i class="far fa-folder mr-2 abtg-smallzone"></i>
        <span class="abtg-smallzone">{{ this.localfolderName }}</span>
        <span>




          <a @click="showModal('m-createFolder', 'old')">
            <span class="fa-stack">
              <i class="fas fa-circle fa-stack-2x" style="color: #c6c5c5"></i>
             <i class="fas fa-pencil-alt fa-stack-1x"></i>
            </span>

          </a>
        </span>
        <span>
          <a @click="showModal('m-deletef')">
            <span class="fa-stack">
              <i class="fas fa-circle fa-stack-2x" style="color: #c6c5c5"></i>
              <i class="fas fa-trash-alt fa-stack-1x"></i>
            </span>

          </a>
        </span>
      </div>


    </div>

    <div class="row mt-3" style="padding-left: 8px;">


      <div
          class="abtg-singlezone d-inline-flex justify-content-between col-lg-2 mx-3"
          :id="z && z.zone ? `abtg-singlezone-${z.zone.toLowerCase()}` : ''"
          v-for="(z, index) in zoneFolderList"
          :key="z.id"
          :class="
              isThisLinkActive({
                zone: z.zone,
                macrozone: z.macrozone,
                microzone: z.microzone,
              })
            "
      >
        <a
            :href="`#${showZoneNameHashtag(z)}`"
            :id="showZoneNameHashtag(z)"
            @click="[removeAllSelectedZones(), buildingByZone({ z, index }), tradeMap=false]"
        >{{ showZoneName(z) }}</a
        >

        <input type="checkbox" v-model="zoneChecked" :value="z.id" :id="z.id">

      </div>

    </div>

    <div class="row mt-3" style="padding-left: 8px;">
      <div class="col-12" style="
    padding-left: 0px;">
        <div class="tools ml-3">
          <div class="btn-group dropright" role="group">
            <a
                id="folderGroup"
                type="button"
                style="margin-top: -3px; padding-right: 30px; color: white !important;text-decoration: underline;"
                class="abtg-all-zones cursor-pointer	"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
            >{{ $t("mapping.move") }}</a>
            <div class="dropdown-menu" aria-labelledby="mapGroup">


              <a
                  v-for="folder in this.allFolder"
                  class="dropdown-item"
                  @click="changeFolderlocal(folder.id)"
              ><i class="fas fa-folder"></i>
                {{ folder.name }}

              </a>

              <a

                  class="dropdown-item font-weight-bold"
                  @click="showModal('m-createFolder', 'new')"
              >{{ $t("mapping.add_folder") }}</a
              >

            </div>
          </div>
        </div>
      </div>
    </div>
    <hr class="abtg__hr-folder my-3">


    <div class="row">

    </div>


    <!-- building list by zone -->
    <transition name="fade" mode="out-in">
      <div
          class="
          card
          abtg__default-card abtg__default-card-border abtg-card-mapping
        "
      >
        <div
            class="card-head"
            v-show="showMappingListCard"
            style="
            text-transform: none !important;
            font-weight: normal !important;
          "
        >
          <header>
            <span class="abtg-smallzone">{{ city }}</span>
            <span v-if="zoneInfo && !showAllZonesInOne" class="abtg-smallzone">
              | {{ zoneInfo.zone }} |
              <span>{{ zoneInfo.macrozone }} | {{ zoneInfo.microzone }}</span>
            </span>
          </header>


          <div v-if="!showAllZonesInOne" class="abtg__header_popover">
            <n-popover
                module="mapping"
                content="list"
                position="right"
            ></n-popover>
          </div>

          <!--Trades-->

          <div class="ml-5" v-if="!showAllZonesInOne">
            <button @click="showTradeResult()"
                    class="mt-2 btn btn-success  abtg__btn-star shadow-none abtg-button-big">
              ARCHIVIO ATTI DI VENDITA
            </button>
          </div>

          <!--End Trades-->


          <div class="tools">
            <div class="btn-group dropleft" role="group">
              <button
                  id="mapGroup"
                  type="button"
                  style="margin-top: -3px"
                  class="btn btn-default shadow-none abtg__btn-tool"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
              >
                &nbsp;
                <i class="fas fa-ellipsis-v"></i>&nbsp;
              </button>

              <div class="dropdown-menu" aria-labelledby="mapGroup">
                <a
                    data-toggle="modal"
                    data-target="#newModalBuilding"
                    @click="setZoneToEdit('m-zone')"
                    class="dropdown-item"
                    v-if="!showAllZonesInOne"
                    style="margin-bottom: -15px !important; text-transform: none"
                >
                  <i class="fas fa-pencil-alt"></i>
                  {{ $t("mapping.link_modifica_dati_zona") }} </a
                >&nbsp;&nbsp;


                <a
                    @click="updateMap()"
                    class="dropdown-item"
                    v-if="!showAllZonesInOne"
                    style="margin-bottom: -15px !important; text-transform: none"
                >
                  <i class="fas fa-map"></i>&nbsp;
                  {{ $t("mapping.link_aggiorna_mappa") }} </a
                >&nbsp;&nbsp;

                <a
                    @click="closeInfoWindowsInMap()"
                    class="dropdown-item"
                    :style="
                    showAllZonesInOne
                      ? 'margin: -10px 0'
                      : 'margin-bottom:-15px !important;'
                  "
                    style="text-transform: none"
                >
                  &nbsp;
                  <i class="fas fa-info"></i>&nbsp;&nbsp;
                  {{ $t("mapping.link_chiudi_info") }} </a
                >&nbsp;&nbsp;

                <a
                    data-toggle="modal"
                    data-target="#newModalBuilding"
                    class="dropdown-item"
                    v-if="!showAllZonesInOne"
                    @click="setMapAndZoneToDelete(zoneInfo.id)"
                    style="margin-bottom: -15px !important; text-transform: none"
                >
                  <i class="fas fa-trash"></i>&nbsp;
                  {{ $t("mapping.link_cancella_zona") }} </a
                >&nbsp;&nbsp;
                <router-link
                    class="dropdown-item"
                    v-if="!showAllZonesInOne"
                    :to="{ name: 'N_Dashboard' }"
                    style="margin-bottom: -15px !important; text-transform: none"
                >
                  <i class="fas fa-plus"></i>&nbsp;
                  {{ $t("mapping.link_nuova_mappatura") }}
                </router-link>
                &nbsp;&nbsp;
              </div>
            </div>
          </div>


        </div>


        <!--        <p v-for="(c, index) in compravendita.compravendita">-->
        <!--            <span v-for="(co, ind) in c">-->
        <!--                  {{ co }}-->
        <!--            </span>-->
        <!--        </p>-->


        <!-- compravendita -->
        <div
            v-if="tradeMap"
            style="margin:25px; background-color:#efefef;padding:15px; width:auto;">
          <h3>Atti di vendita ricercati</h3>
          <span v-if="tradeResult.length === 0">
            Non è stata fatta alcuna ricerca in questa zona.
            <a href="/services/compravendita"><strong>Cerca gli atti di vendita di questa zona</strong></a>
          </span>
          <span v-for="(t, index) in tradeResult">
                  <p>Atto di vendita: <strong>{{ t.attovendita }}</strong></p>
                  <p>Prezzo: <strong>€ {{ t.prezzo }}</strong></p>
                  <p>Totale immobili: <strong>{{ t.totaleimmobili }}</strong></p>


                <table class=" table table-striped">
                  <thead>
                  <tr>
                    <th nowrap>Mese/Anno Stipula</th>
                    <th nowrap>Categ. Catast.</th>
                    <th nowrap>Città</th>
                    <th nowrap>Cod Cat</th>
                    <th nowrap>Cod Uff</th>
                    <th nowrap>Consist.</th>
                    <th nowrap>Decod. atto</th>
                    <th nowrap>Indirizzo</th>
                    <th nowrap>Fog./Par.</th>
                    <th nowrap>Quota fav.</th>
                    <th nowrap>Set. merc.</th>
                    <th nowrap>Superf.</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(build, buildIndex) in t.buildings">
                    <td>{{ build.mesestipula }}/{{ build.annostipula }}</td>
                    <td>{{ build.categoriacat }} </td>
                    <td>{{ build.citta }}</td>
                    <td>{{ build.codcat }}</td>
                    <td>{{ build.coduff }} / {{ build.regpart }}</td>
                    <td>{{ build.consistenza }}</td>
                    <td>{{ build.decodificaatto }}</td>
                    <td><a
                        :href="'https://www.google.com/maps/search/?api=1&query=' + build.locationpoint"
                        target="_blank">{{ build.dizione }}({{ build.provincia }}) - {{ build.indirizzo }}</a><br>
                    zona: {{ build.zona }}<br> zonaomi {{ build.zonaomi }}</td>
                    <td>{{ build.foglio }}/{{ build.particella }}</td>
                    <td>{{ build.quotafavore }}</td>
                    <td>{{ build.settoremercato }}</td>
                    <td>mq {{ build.superficie }}</td>
                  </tr>
                  </tbody>
                </table>
          </span>
        </div>
        <!-- stop compravendita -->


        <div class="card-body" v-if="(zoneInfo && zoneInfo.latlng) || zoneListOfCity">

          <!-- MAP Google -->


          <!--          <div v-if="standardMap">-->
          <n-gmap
              :key="componentKey"
              v-if="!tradeMap"
              v-bind:content="{
              zoneInfo: zoneInfo,
              zoneListOfCity: zoneListOfCity,
              showAllZonesInOne: showAllZonesInOne,
              showGoogleMap: true,
              searchType: 'mapping',
            }"
          ></n-gmap>
          <!--          </div>-->


          <!--          <div v-if="tradeMap">-->
          <!--            <mappa-->
          <!--                :zoneInfo="zoneInfo"-->
          <!--            >-->
          <!--            </mappa>-->
          <!--          </div>-->


          <!-- END Google -->

          <!-- price and street price -->

          <div v-if="!checkComp">
            <div
                class="row abtg__air20"
                v-show="showMappingListCard && !showAllZonesInOne"
            >
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div class="abtg__streetprice-wrapper">
                <span
                    class="abtg__text"
                    style="padding-right: 20px; border-right: 2px solid #ccc"
                >
                  <b>€ {{ priceMq | currency }} </b>
                  {{ $t("mapping.text_media_prezzo") }}</span
                >
                  <span class="abtg__text abtg__text-abtg">
                  <b>€ {{ streetPrice | currency }} </b>
                  {{ $t("valutation.street_price") }} (-{{
                      100 - streetPricePercentage
                    }}%)</span
                  >

                  <button
                      class="btn btn-default shadow-none abtg__btn-tool"
                      :class="
                    streetPricePercentage === 90
                      ? 'abtg__btn-third-reverse'
                      : 'abtg__btn-third'
                  "
                      style="margin-top: 7px"
                      @click.stop="
                    [
                      SET_DATA({ name: 'activateLoading', data: true }),
                      buildingByZone({ z: zoneInfo, streetPrice: 90 }),
                    ]
                  "
                  >
                    Street price al 10%
                  </button>

                  <button
                      class="btn btn-default shadow-none abtg__btn-tool"
                      :class="
                    streetPricePercentage === 80
                      ? 'abtg__btn-third-reverse'
                      : 'abtg__btn-third'
                  "
                      style="margin-top: 7px"
                      @click.stop="
                    [
                      SET_DATA({ name: 'activateLoading', data: true }),
                      buildingByZone({ z: zoneInfo, streetPrice: 80 }),
                    ]
                  "
                  >
                    Street price al 20%
                  </button>

                  <button
                      class="btn btn-default shadow-none abtg__btn-tool"
                      :class="
                    streetPricePercentage === 70
                      ? 'abtg__btn-third-reverse'
                      : 'abtg__btn-third'
                  "
                      style="margin-top: 7px"
                      @click.stop="
                    [
                      SET_DATA({ name: 'activateLoading', data: true }),
                      buildingByZone({ z: zoneInfo, streetPrice: 70 }),
                    ]
                  "
                  >
                    Street price al 30%
                  </button>

                  <a
                      href="#"
                      v-if="zoneInfo && zoneInfo.auctionId > 0"
                      class="
                    btn btn-default
                    abtg__btn-star
                    shadow-none
                    abtg__btn-tool
                  "
                      @click="
                    saveStreetPriceInAuction({
                      auctionID: zoneInfo.auctionId,
                      streetPrice: streetPrice,
                    })
                  "
                  >Salva questo Street Price e ritorna all'asta</a
                  >
                </div>
              </div>

              <div class="col-12">
                <div class="btn-group">
                  <button
                      class="btn btn-default shadow-none abtg__btn-tool"
                      :class="
                    buildingType === 1
                      ? 'abtg__btn-third-reverse'
                      : 'abtg__btn-third'
                  "
                      style="margin-top: 7px"
                      @click.stop="
                    [
                      SET_DATA({ name: 'activateLoading', data: true }),
                      SET_DATA({ name: 'buildingType', data: 1 }),
                      buildingByZone({ z: zoneInfo }),
                    ]
                  "
                  >
                    {{ $t("mapping.link_immobili_residenziali") }}
                  </button>

                  <button
                      class="btn btn-default shadow-none abtg__btn-tool ml-2"
                      :class="
                    buildingType === 2
                      ? 'abtg__btn-third-reverse'
                      : 'abtg__btn-third'
                  "
                      style="margin-top: 7px"
                      @click.stop="
                    [
                      SET_DATA({ name: 'activateLoading', data: true }),
                      SET_DATA({ name: 'buildingType', data: 2 }),
                      buildingByZone({ z: zoneInfo }),
                    ]
                  "
                  >
                    {{ $t("mapping.link_immobili_commerciali") }}
                  </button>

                  <button
                      class="btn btn-default shadow-none abtg__btn-tool ml-2"
                      :class="
                    renovated === 1
                      ? 'abtg__btn-third-reverse'
                      : 'abtg__btn-third'
                  "
                      style="margin-top: 7px"
                      @click.stop="
                    [
                      SET_DATA({ name: 'activateLoading', data: true }),
                      SET_DATA({ name: 'renovated', data: 1 }),
                      buildingByZone({ z: zoneInfo }),
                    ]
                  "
                  >
                    {{ $t("mapping.ristrutturato_si") }}
                  </button>

                  <button
                      class="btn btn-default shadow-none abtg__btn-tool ml-2"
                      :class="
                    renovated === 2
                      ? 'abtg__btn-third-reverse'
                      : 'abtg__btn-third'
                  "
                      style="margin-top: 7px"
                      @click.stop="
                    [
                      SET_DATA({ name: 'activateLoading', data: true }),
                      SET_DATA({ name: 'renovated', data: 2 }),
                      buildingByZone({ z: zoneInfo }),
                    ]
                  "
                  >
                    {{ $t("mapping.ristrutturato_no") }}
                  </button>


                  <button
                      class="btn btn-default shadow-none abtg__btn-tool ml-2"
                      :class="
                    renovated === 3
                      ? 'abtg__btn-third-reverse'
                      : 'abtg__btn-third'
                  "
                      style="margin-top: 7px"
                      @click.stop="
                    [
                      SET_DATA({ name: 'activateLoading', data: true }),
                      SET_DATA({ name: 'renovated', data: 3 }),
                      buildingByZone({ z: zoneInfo }),
                    ]
                  "
                  >
                    {{ $t("mapping.ristrutturato_ni") }}
                  </button>


                  <button
                      onClick="window.location.reload();"
                      class="btn btn-default shadow-none abtg__btn-tool ml-2 mt-2"


                  >
                    {{ $t("mapping.azzera_filtri") }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div v-else>
            <div
                class="row abtg__air20"
                v-show="showMappingListCard && !showAllZonesInOne"
            >
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div class="abtg__streetprice-wrapper">
                <span
                    class="abtg__text"
                    style="padding-right: 20px; border-right: 2px solid #ccc"
                >
                  <b>€ {{ priceMq | currency }} </b>
                  {{ $t("mapping.text_media_prezzo") }}</span
                >
                  <span class="abtg__text abtg__text-abtg">
                  <b>€ {{ streetPrice | currency }} </b>
                  {{ $t("valutation.street_price") }} (-{{
                      100 - streetPricePercentage
                    }}%)</span
                  >

                  <button
                      class="btn btn-default shadow-none abtg__btn-tool"
                      :class="
                    streetPricePercentage === 90
                      ? 'abtg__btn-third-reverse'
                      : 'abtg__btn-third'
                  "
                      style="margin-top: 7px"
                      @click.stop="
                    [
                      SET_DATA({ name: 'activateLoading', data: true }),
                      comparabili({ z: zoneInfo, streetPrice: 90 }),
                    ]
                  "
                  >
                    Street price al 10%
                  </button>

                  <button
                      class="btn btn-default shadow-none abtg__btn-tool"
                      :class="
                    streetPricePercentage === 80
                      ? 'abtg__btn-third-reverse'
                      : 'abtg__btn-third'
                  "
                      style="margin-top: 7px"
                      @click.stop="
                    [
                      SET_DATA({ name: 'activateLoading', data: true }),
                      comparabili({ z: zoneInfo, streetPrice: 80 }),
                    ]
                  "
                  >
                    Street price al 20%
                  </button>

                  <button
                      class="btn btn-default shadow-none abtg__btn-tool"
                      :class="
                    streetPricePercentage === 70
                      ? 'abtg__btn-third-reverse'
                      : 'abtg__btn-third'
                  "
                      style="margin-top: 7px"
                      @click.stop="
                    [
                      SET_DATA({ name: 'activateLoading', data: true }),
                      comparabili({ z: zoneInfo, streetPrice: 70 }),
                    ]
                  "
                  >
                    Street price al 30%
                  </button>

                  <a
                      href="#"
                      v-if="zoneInfo && zoneInfo.auctionId > 0"
                      class="
                    btn btn-default
                    abtg__btn-star
                    shadow-none
                    abtg__btn-tool
                  "
                      @click="
                    saveStreetPriceInAuction({
                      auctionID: zoneInfo.auctionId,
                      streetPrice: streetPrice,
                    })
                  "
                  >Salva questo Street Price e ritorna all'asta</a
                  >
                </div>
              </div>

              <div class="col-12">
                <div class="btn-group">
                  <button
                      class="btn btn-default shadow-none abtg__btn-tool"
                      :class="
                    buildingType === 1
                      ? 'abtg__btn-third-reverse'
                      : 'abtg__btn-third'
                  "
                      style="margin-top: 7px"
                      @click.stop="
                    [
                      SET_DATA({ name: 'activateLoading', data: true }),
                      SET_DATA({ name: 'buildingType', data: 1 }),
                      buildingByZone({ z: zoneInfo }),
                    ]
                  "
                  >
                    {{ $t("mapping.link_immobili_residenziali") }}
                  </button>

                  <button
                      class="btn btn-default shadow-none abtg__btn-tool ml-2"
                      :class="
                    buildingType === 2
                      ? 'abtg__btn-third-reverse'
                      : 'abtg__btn-third'
                  "
                      style="margin-top: 7px"
                      @click.stop="
                    [
                      SET_DATA({ name: 'activateLoading', data: true }),
                      SET_DATA({ name: 'buildingType', data: 2 }),
                      buildingByZone({ z: zoneInfo }),
                    ]
                  "
                  >
                    {{ $t("mapping.link_immobili_commerciali") }}
                  </button>

                  <button
                      class="btn btn-default shadow-none abtg__btn-tool ml-2"
                      :class="
                    renovated === 1
                      ? 'abtg__btn-third-reverse'
                      : 'abtg__btn-third'
                  "
                      style="margin-top: 7px"
                      @click.stop="
                    [
                      SET_DATA({ name: 'activateLoading', data: true }),
                      SET_DATA({ name: 'renovated', data: 1 }),
                      buildingByZone({ z: zoneInfo }),
                    ]
                  "
                  >
                    {{ $t("mapping.ristrutturato_si") }}
                  </button>

                  <button
                      class="btn btn-default shadow-none abtg__btn-tool ml-2"
                      :class="
                    renovated === 2
                      ? 'abtg__btn-third-reverse'
                      : 'abtg__btn-third'
                  "
                      style="margin-top: 7px"
                      @click.stop="
                    [
                      SET_DATA({ name: 'activateLoading', data: true }),
                      SET_DATA({ name: 'renovated', data: 2 }),
                      buildingByZone({ z: zoneInfo }),
                    ]
                  "
                  >
                    {{ $t("mapping.ristrutturato_no") }}
                  </button>


                  <button
                      class="btn btn-default shadow-none abtg__btn-tool ml-2"
                      :class="
                    renovated === 3
                      ? 'abtg__btn-third-reverse'
                      : 'abtg__btn-third'
                  "
                      style="margin-top: 7px"
                      @click.stop="
                    [
                      SET_DATA({ name: 'activateLoading', data: true }),
                      SET_DATA({ name: 'renovated', data: 3 }),
                      buildingByZone({ z: zoneInfo }),
                    ]
                  "
                  >
                    {{ $t("mapping.ristrutturato_ni") }}
                  </button>


                  <button
                      onClick="window.location.reload();"
                      class="btn btn-default shadow-none abtg__btn-tool ml-2 mt-2"


                  >
                    {{ $t("mapping.azzera_filtri") }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <br/>

          <!-- tab mq -->
          <ul
              class="nav nav-tabs"
              v-show="showMappingListCard && !showAllZonesInOne"
          >
            <li class="nav-item abtg__item">
              <a :class="ac[0]" @click="(retrieveMqRange(0, null, null), checkComp = false)">All</a>
            </li>
            <li class="nav-item abtg__item">
              <a :class="ac[50]" @click="(retrieveMqRange(50, null, null), checkComp = false)">
                < 50mq
              </a>
            </li>
            <li class="nav-item abtg__item">
              <a :class="ac[70]" @click="(retrieveMqRange(70, null, null), checkComp = false)"
              >50/70mq</a
              >
            </li>
            <li class="nav-item abtg__item">
              <a :class="ac[90]" @click="(retrieveMqRange(90, null, null), checkComp = false)"
              >70/90mq</a
              >
            </li>
            <li class="nav-item abtg__item">
              <a :class="ac[110]" @click="(retrieveMqRange(110, null, null), checkComp = false)"
              >90/110mq</a
              >
            </li>
            <li class="nav-item abtg__item">
              <a :class="ac[111]" @click="(retrieveMqRange(111, null, null), checkComp = false)"
              >> 110mq</a
              >
            </li>

            <li class="nav-item abtg__item" v-for="(r, index) in customRange">
              <a
                  :class="customAc[index]"
                  @click="retrieveMqRange(null, r, index)"
                  style="color: green; font-weight: bold"
              >{{ r.min }}/{{ r.max }}
              </a>
            </li>

            <li class="nav-item abtg__item">
              <button
                  class="
                  btn btn-default
                  abtg__btn-third
                  shadow-none
                  abtg__btn-tool
                "
                  @click="showModal('m-range')"
              >
                <i class="fas fa-plus"></i>
              </button>
            </li>

            <li class="nav-item abtg__item">
              <a :class="ac[444]" @click="(getComparabili(0, null, null), checkComp = true)"
              >Comparabili</a>
            </li>


          </ul>
          <!-- end tab mq -->

          <!-- // end subheader -->

          <div
              class="table-responsive"
              v-show="showMappingListCard && !showAllZonesInOne"
          >
            <div style="float: right">
              <div class="btn-group dropleft" role="group">
                <button
                    id="mapGroup2"
                    type="button"
                    style="margin-top: -3px"
                    class="btn btn-default shadow-none abtg__btn-tool"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                >
                  &nbsp;
                  <i class="fas fa-ellipsis-v"></i>&nbsp;
                </button>
                <div class="dropdown-menu" aria-labelledby="mapGroup2">
                  <a
                      href="#"
                      @click.prevent="exportExcel()"
                      class="dropdown-item"
                      style="text-transform: none"
                  >
                    <i class="far fa-file-excel"></i>&nbsp;
                    {{ $t("mapping.link_esporta_excel") }}
                  </a>

                  <a
                      href="#"
                      data-toggle="modal"
                      data-target="#newModalBuilding"
                      style="text-transform: none"
                      class="dropdown-item"
                      @click.prevent="newBuilding()"
                  >
                    <i class="fas fa-plus"></i>&nbsp;
                    {{ $t("mapping.link_carica_immobile") }}
                  </a>

                  <a
                      href="#"
                      data-toggle="modal"
                      data-target="#newModalBuilding"
                      style="text-transform: none"
                      class="dropdown-item"
                      @click.prevent="checkAds"
                  >
                    <i class="fas fa-sync"></i>&nbsp;
                    {{ $t("mapping.link_controlla_annunci") }}
                  </a>

                  <a
                      href="#"
                      style="text-transform: none"
                      class="dropdown-item"
                      @click.prevent="reloadBuildings"
                  >
                    <i class="fas fa-euro-sign"></i>&nbsp;
                    {{ $t("mapping.link_ricalcola_scostamento") }}
                  </a>
                </div>
              </div>
              <!-- end -->
            </div>

            <div style="float: right; margin-top: -6px">
              <!--              <p class="" v-if="rotateSpin.length > 0" style="padding:5px; margin-right:5px; background-color:#ececec"> il servizio è temporanemanete sospeso per aggiornamenti</p>-->

              <span
                  v-if="rotateSpin.length > 0"
                  class=""
                  style="
                  background-color: #efefef;
                  color: black;
                  margin-top: 5px;
                  margin-bottom: 5px;
                  float: right;
                  text-align: right !important;
                "
              >
                {{ $t("mapping.text_sto_controllando") }}
              </span>
              <a
                  v-if="showBinOnlyIfThereIsOneOutdated"
                  @click="deleteAdsOutdated"
                  style="
                  margin-top: 5px;
                  margin-bottom: 5px;
                  float: right;
                  text-align: right !important;
                  background-color: red !important;
                "
                  class="
                  btn btn-default
                  abtg__btn-star
                  shadow-none
                  abtg__btn-tool
                "
              >{{ $t("mapping.link_cancella") }}
                <i class="fas fa-trash"></i>
              </a>
            </div>
            <table class="mdl-data-table ml-table-striped ml-table-bordered mdl-js-data-table is-upgraded">
              <thead>
              <tr class="d-flex">
                <th class="col-1"></th>
                <th class="text-left abtg__vertical-align col-1">
                    <span class="abtg__text-abtg">{{
                        $t("mapping.table_deviation")
                      }}</span>
                </th>
                <th class="text-left abtg__vertical-align col-1">
                    <span class="abtg__text-abtg">
                      <i class="far fa-star"></i>
                    </span>
                </th>
                <th class="text-left abtg__vertical-align col-2">
                    <span class="abtg__text-abtg">{{
                        $t("mapping.table_address")
                      }}</span>
                </th>
                <th class="text-left abtg__vertical-align col-1">
                    <span class="abtg__text-abtg">{{
                        $t("mapping.ristrutturazione")
                      }}</span>
                </th>
                <th class="text-left abtg__vertical-align col-1">
                    <span class="abtg__text-abtg">{{
                        $t("mapping.table_floor")
                      }}</span>
                </th>
                <th class="text-left abtg__vertical-align col-1">
                    <span class="abtg__text-abtg">{{
                        $t("mapping.table_room")
                      }}</span>
                </th>
                <th class="text-left abtg__vertical-align col-1">
                    <span class="abtg__text-abtg">{{
                        $t("mapping.table_mq")
                      }}</span>
                </th>
                <th class="text-left abtg__vertical-align col-2">
                    <span class="abtg__text-abtg">{{
                        $t("mapping.table_price")
                      }}</span>
                </th>

                <th class="text-left col-1"></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(m, index) in buildingList" class="d-flex">

                <td class="align-top col-1 d-flex" :class="isClone(m.clone)">

                  <div :style="ac[444] ? '' : 'border-right: 1px solid #888383; margin-right: 15px' ">
                    <label>
                      <input
                          type="checkbox"
                          class="md-toggle"
                          style="margin-left: -10px !important"
                          v-model="m.comparable"
                          :key="index"
                          @change="setComparable(m.id)"
                      />
                    </label>
                    <p style="font-size: 10px; margin-top: -10px; font-weight: bold">Comp.</p>
                  </div>

                  <label class="ml-2" v-if="!ac[444]">
                    <input
                        type="checkbox"
                        class="md-toggle ml-2"
                        style="margin-left: -10px !important"
                        v-model="m.active"
                        :key="index"
                        @click.stop="activateDeactivate({ id: m.id })"
                    />
                  </label>
                </td>
                <td class="align-top col-1" :class="isClone(m.clone)">
                    <span
                        v-html="DEVIATION_COLOR(m.scostamento)"
                        v-if="m.active === 1"
                    ></span>
                  <span v-else="m.active === 0">-</span>
                </td>
                <td class="mdl-data-table__cell--non-numeric align-top col-1" :class="isClone(m.clone)">
                  {{ STATUS(m.status) }}
                </td>
                <td class="align-top col-2" :class="isClone(m.clone)">
                  <div
                      v-if="isClone(m.clone)"
                      class="alert alert-warning"
                      style="font-size: 80%"
                  >
                    {{ $t('mapping.probabile_doppione') }}
                    <br/>
                    <a @click="setIdToNotClone(m.id)" href="#"
                       class="text-success">{{ $t('mapping.non_e_doppione') }}</a>
                    <br/>
                    <a @click="setIdToDelete(m.id)" href="#" class="text-danger" data-toggle="modal"
                       data-target="#modalSingleMapping">{{ $t('mapping.elimina_doppione') }}</a>

                  </div>
<!--                  controllo validità link-->
                  <span v-if="m.broken_link === 1" class="small">

                                        <a :href="m.link" target="_blank"
                                            style="color: red; font-size: 120%"
                                            title="Annuncio non più presente sul portale">
                                         <i class="fas fa-link"></i>
                                          controlla se valido
                                        </a> <hr style="height: 4pt; margin: 0 !important; visibility:hidden;" />
                                      <a @click="removeCheckBrokenLink(m.id)" style="
                                            width: auto;
                                            font-size: 120%;
                                            background: #04c504;
                                            color: white;
                                            padding: 5px;">
                                          <strong>confermo, è valido</strong>
                                        </a> <hr style="height: 4pt; margin: 0 !important; visibility:hidden;" />
                  </span>

                  <span :ref="`addressText${m.id}`"
                      @mouseenter="showPencilIcon($event.target)"
                      @mouseleave="showPencilIcon($event.target)"
                      @click="showAddressInput(m.id, true)">
                      {{ WORD_CUT(ADDRESS_REPLACE(m.via), 30) }}
                    </span>
                  <i
                      class="fas fa-pencil-alt hidden"
                      style="font-size: 16px"
                  ></i>
                  <input
                      type="text"
                      class="hidden"
                      v-model="m.via"
                      style="border: none; background-color: transparent"
                      @input="updateBuildingInline(m)"
                      @focusout="showAddressInput(m.id)"
                      :ref="`addressInput${m.id}`"
                  />
                  <br/>
                  <a v-if="m.broken_link !== 1" :href="m.link" target="_blank">{{ whichPortal(m.link) }}</a>
                </td>
                <td class="align-top col-1" :class="isClone(m.clone)">
                    <span
                        @click="showRenovatedSelection(m)"
                        @mouseenter="showPencilIcon($event.target)"
                        @mouseleave="showPencilIcon($event.target)"
                        :ref="`renovatedText${m.id}`"
                    >{{ labelRenovation({renovated: m.renovated}) }}</span
                    >
                  <i
                      class="fas fa-pencil-alt hidden"
                      style="font-size: 16px"
                  ></i>
                  <div class="hidden" :ref="`renovatedSelection${m.id}`">
                    <div class="">
                      <a
                          href="#"
                          class=""
                          style="color: black"
                          @click.prevent="
                            [
                              showRenovatedSelection(m),
                              (m.renovated = 1),
                              updateBuildingInline(m),
                            ]
                          "
                          :style="
                            m.renovated === 1
                              ? 'border-bottom: 1px solid; font-weight: bold'
                              : ''
                          "
                      >
                        Sì</a
                      >
                      &nbsp;&nbsp;&nbsp;
                      <a
                          href="#"
                          class=""
                          style="color: black"
                          @click.prevent="
                            [
                              showRenovatedSelection(m),
                              (m.renovated = 2),
                              updateBuildingInline(m),
                            ]
                          "
                          :style="
                            m.renovated === 2
                              ? 'border-bottom: 1px solid; font-weight: bold'
                              : ''
                          "
                      >
                        No</a
                      >
                    </div>

                    <div class="mt-1">
                      <a
                          href="#"
                          class=""
                          style="color: black"
                          @click.prevent="
                            [
                              showRenovatedSelection(m),
                              (m.renovated = 3),
                              updateBuildingInline(m),
                            ]
                          "
                          :style="
                            m.renovated === 3
                              ? 'border-bottom: 1px solid; font-weight: bold'
                              : ''
                          "
                      >
                        "NI"</a
                      >
                    </div>
                  </div>
                </td>
                <td class="align-top col-1" :class="isClone(m.clone)">
                    <span
                        :class="!m.piano ? 'p-5' : ''"
                        @mouseenter="showPencilIcon($event.target)"
                        @mouseleave="showPencilIcon($event.target)"
                        @click="showFloorInput(m.id, true)"
                        :ref="`floorText${m.id}`"
                    >{{ m.piano }}</span
                    >
                  <i
                      class="fas fa-pencil-alt hidden"
                      style="font-size: 16px"
                  ></i>
                  <input
                      type="text"
                      class="hidden"
                      v-model="m.piano"
                      style="
                        max-width: 50px;
                        border: none;
                        background-color: transparent;
                      "
                      @input="updateBuildingInline(m)"
                      @focusout="showFloorInput(m.id)"
                      :ref="`floorInput${m.id}`"
                  />
                </td>
                <td class="align-top col-1" :class="isClone(m.clone)">
                    <span
                        :class="!m.locali ? 'p-5' : ''"
                        @mouseenter="showPencilIcon($event.target)"
                        @mouseleave="showPencilIcon($event.target)"
                        @click="showRoomsInput(m.id, true)"
                        :ref="`roomsText${m.id}`"
                    >{{ m.locali }}</span
                    >
                  <i
                      class="fas fa-pencil-alt hidden"
                      style="font-size: 16px"
                  ></i>
                  <input
                      type="number"
                      class="hidden"
                      v-model="m.locali"
                      style="
                        max-width: 50px;
                        border: none;
                        background-color: transparent;
                      "
                      @input="updateBuildingInline(m)"
                      @focusout="showRoomsInput(m.id)"
                      :ref="`roomsInput${m.id}`"
                  />
                </td>
                <td class="mdl-data-table__cell--non-numeric align-top col-1" :class="isClone(m.clone)">
                    <span
                        :class="!m.mq ? 'p-5' : ''"
                        @click="showMqInput(m.id, true)"
                        @mouseenter="showPencilIcon($event.target)"
                        @mouseleave="showPencilIcon($event.target)"
                        :ref="`mqText${m.id}`"
                    >{{ m.mq }}</span
                    >
                  <i
                      class="fas fa-pencil-alt hidden"
                      style="font-size: 16px"
                  ></i>
                  <input
                      type="number"
                      class="hidden"
                      v-model="m.mq"
                      style="
                        max-width: 85px;
                        border: none;
                        background-color: transparent;
                      "
                      @input="updateBuildingInline(m)"
                      @focusout="[showMqInput(m.id), reloadBuildings()]"
                      :ref="`mqInput${m.id}`"
                  />
                </td>

                <td class="mdl-data-table__cell--non-numeric align-top col-2" :class="isClone(m.clone)">
                    <span
                        @click="showPriceInput(m.id, true)"
                        @mouseenter="showPencilIcon($event.target)"
                        @mouseleave="showPencilIcon($event.target)"
                        :ref="`priceText${m.id}`"
                    >{{ FORMAT_PRICE(m.prezzo) || 0.0 }}</span
                    >
                  <i
                      class="fas fa-pencil-alt hidden"
                      style="font-size: 16px"
                  ></i>
                  <input
                      type="number"
                      class="hidden"
                      v-model="m.prezzo"
                      style="border: none; background-color: transparent"
                      @input="updateBuildingInline(m)"
                      @focusout="[showPriceInput(m.id), reloadBuildings()]"
                      :ref="`priceInput${m.id}`"
                  />
                  <em>({{ getPriceMq(m.prezzo, m.mq) }})</em>
                </td>

                <td class="align-top col-1" :class="isClone(m.clone)">
                  <div class="btn-group" role="group">
                    <button
                        id="btnGroupDrop1"
                        type="button"
                        style="margin-top: -3px"
                        class="
                          btn btn-default
                          shadow-none
                          abtg__btn-tool
                          dropdown-toggle
                        "
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                      &nbsp;
                      <i class="fas fa-ellipsis-v"></i>&nbsp;
                    </button>

                    <div
                        class="dropdown-menu"
                        aria-labelledby="btnGroupDrop1"
                    >
                      <a
                          class="dropdown-item"
                          style="
                            margin-bottom: -15px !important;
                            text-transform: none;
                          "
                          @click="editBuilding(m)"
                      >
                        <i class="fas fa-list"></i>&nbsp;
                        {{ $t("mapping.link_modifica") }} </a
                      >&nbsp;&nbsp;
                      <a
                          class="dropdown-item"
                          style="
                            margin-bottom: -15px !important;
                            text-transform: none;
                          "
                          @click="
                            createOperation({
                              idBuilding: m.id,
                              streetPrice: streetPrice,
                            })
                          "
                      >
                        <i class="fas fa-calculator"></i>&nbsp;
                        {{ $t("mapping.link_conto") }} </a
                      >&nbsp;&nbsp;
                      <a
                          class="dropdown-item"
                          data-toggle="modal"
                          data-target="#modalSingleMapping"
                          style="
                            margin-bottom: -15px !important;
                            text-transform: none;
                          "
                          @click="setIdToDelete(m.id)"
                      >
                        <i class="far fa-trash-alt"></i>&nbsp;
                        {{ $t("mapping.link_cancella_stop") }}
                      </a>
                      &nbsp;&nbsp;
                    </div>
                  </div>

                  <div class="btn-group" role="group">
                    <button
                        id="btnGroupDrop2"
                        type="button"
                        style="margin-top: -3px"
                        class="
                          btn btn-default
                          shadow-none
                          abtg__btn-tool
                          dropdown-toggle
                        "
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                    >
                      &nbsp;
                      <i class="far fa-star"></i>&nbsp;
                    </button>
                    <div
                        class="dropdown-menu pb-4"
                        aria-labelledby="btnGroupDrop2"
                    >
                      <a
                          class="dropdown-item"
                          style="
                            margin-bottom: -15px !important;
                            text-transform: none;
                          "
                          @click="changeStatus({ building: m, status: 1 })"
                      >
                        <i class="far fa-star"></i>&nbsp; In analisi </a
                      >&nbsp;&nbsp;
                      <a
                          class="dropdown-item"
                          style="
                            margin-bottom: -15px !important;
                            text-transform: none;
                          "
                          @click="changeStatus({ building: m, status: 2 })"
                      >
                        <i class="far fa-star"></i>&nbsp; In corso </a
                      >&nbsp;&nbsp;
                      <a
                          class="dropdown-item"
                          data-toggle="modal"
                          data-target="#modalSingleMapping"
                          style="
                            margin-bottom: -15px !important;
                            text-transform: none;
                          "
                          @click="changeStatus({ building: m, status: 3 })"
                      >
                        <i class="far fa-star"></i>&nbsp; Chiuso
                      </a>
                      <a
                          class="dropdown-item pt-2"
                          data-toggle="modal"
                          data-target="#modalSingleMapping"
                          style="
                            margin: 20px 0 -15px !important;
                            text-transform: none;
                          "
                          @click="changeStatus({ building: m, status: 0 })"
                      >
                        <i class="far fa-star" style="color: transparent"></i
                        >&nbsp; Nessuno
                      </a>
                    </div>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>

          </div>
        </div>


      </div>
    </transition>
    <!-- end building list by zone -->
  </div>
</template>
<script>
import NBread from "@/partials/bread";
import NPopover from "@/partials/popover";
import NRange from "@/partials/mapping/modal_range";
import NModalBuilding from "@/partials/mapping/modal_building";
import NGmap from "@/partials/mapping/gmap";
import NDelete from "@/partials/modal_delete";
import NDeletef from "@/partials/modal_deletefolder";
import NCreate from "@/partials/modal_createFolder";
import mappa from "@/partials/clickMap/mappa"
import NModalZone from "@/partials/mapping/modal_zone";
import {mixin} from "@/helpers/helper";
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

export default {
  mixins: [mixin],
  components: {
    NBread,
    NPopover,
    NRange,
    NModalBuilding,
    NGmap,
    NDelete,
    NDeletef,
    NModalZone,
    NCreate,
    mappa
  },

  data() {
    return {
      more: true,
      selectedZone: {},
      nameFolder: "",
      editFolder: false,
      zoneChecked: [],
      localfolderId: 0,
      localfolderName: "",
      showFolderModal: false,
      i: 0,
      tradeMap: false,
      standardMap: true,
      tradeResult: null,
      checkComp: false
    }
  },

  created() {
    this.trackActivity();
    this.lang = window.localStorage.getItem("language");

    if (this.lang === "es") {
      this.SET_DATA({
        name: "bread_active",
        data: {label: "Archivos de mapeo"},
      });
    } else {
      this.SET_DATA({
        name: "bread_active",
        data: {label: "Archivio mappatura"},
      });
    }

    this.regionByUser();


    if (this.handleUrl('cityId') === null && this.handleUrl('city') === null) {
      this.lastMapping({route: this.$route});

    } else {
      this.changeZoneByUrl();
    }

    setTimeout(() => {
      this.allFolderByCity();
    }, 1000)


  },

  watch: {
    zoneInfo(val) {
      if (
          val &&
          Object.keys(val).length > 0 &&
          Object.keys(this.selectedZone).length === 0
      ) {
        this.selectedZone = {
          cityId: val.m_cities.id,
          city: val.m_cities.comune,
        };
      }
    },

    streetPriceSaved(oldValue, newValue) {
      if (oldValue != newValue) {
        this.$router.push({path: "/auction"});
      }
    },

    selectedZone(value) {
      // if (!this.startLastMapping) {
      //  // this.zoneByCity(value);
      // }


      this.SET_DATA({
        name: "startLastMapping",
        data: false,
      });
    },

    zoneList(value) {
      if (this.$route.params.zone_id) {
        this.setMappingZone({id: this.$route.params.zone_id});
      }

      setTimeout(() => {
        this.checkIfHasExist();
      }, 500);
    },

  },
  computed: {
    ...mapState("n_mapping", [
      "bread_active",
      "bread_list",
      "regionList",
      "zoneList",
      "zoneListOfCity",
      "compravendita",
      "buildingList",
      "streetPrice",
      "customRange",
      "ac",
      "customAc",
      "formData",
      "myError",
      "showMappingListCard",
      "closeAfterSave",
      "city",
      "cityId",
      "zoneInfo",
      "componentKey",
      "cityAc",
      "zoneAc",
      "buildingType",
      "rotateColorSpin",
      "rotateSpin",
      "showBinIcon",
      "showAllZonesInOne",
      "activeAllZone",
      "idZoneToDelete",
      'idNotClone',
      "startLastMapping",
      "forcePageRefresh",
      "activateLoading",
      "streetPricePercentage",
      "userCountry",
      "folderName",
      "checkedZones",
      "allFolder",
      "zoneFolderList",
      "folderid",
      "renovated",

    ]),
    ...mapState("n_auction", ["streetPriceSaved"]),
    ...mapGetters("n_mapping", ["priceMq"]),

    orderedRegionList() {
      if (this.regionList) {
        return this.regionList.sort((a, b) => {
          if (b.city > a.city) {
            return -1;
          }
          return 1;
        });
      }
    },

    showBinOnlyIfThereIsOneOutdated() {
      //if (this.showBinIcon === true) {
      let onlyOne = this.buildingList.filter(function (p) {
        return p.broken_link === 1;
      });
      return onlyOne.length > 0 ? true : false;
      //}
    },
  },

  methods: {
    ...mapActions("n_mapping", [
      "removeCheckBrokenLink",
      "regionByUser",
      "zoneByCity",
      "buildingByZone",
      "comparabili",
      "tabOn",
      "saveCustomRangeData",
      "deleteCustomRange",
      "clearForm",
      "sendMappingData",
      "lastMapping",
      "exportExcel",
      "deleteBuilding",
      "notClone",
      "createOperation",
      "activateDeactivate",
      "checkAds",
      "deleteAdsOutdated",
      "changeStatus",
      "deleteZone",
      "allZoneByCity",
      "editZoneData",
      "retrieveMappedBuilding",
      "reloadBuildings",
      "saveFolder",
      "changeFolder",
      "allFolderByCity",
      "deleteFolder"

    ]),
    ...mapActions("n_auction", ["saveStreetPriceInAuction"]),
    ...mapMutations("n_mapping", ["SET_DATA"]),


    setComparable(payload) {
      axios.post('/api/v2/mapping/setComparable', {id: payload})
    },


    showTradesMap() {
      this.tradeMap = !this.tradeMap
      this.standardMap = !this.standardMap
    },

    showTradeResult() {
      this.tradeMap = true;
      axios.get(`/api/v2/trades/zoneResult/?zoneId=${this.zoneInfo.id}`)
          .then(response => {
            this.tradeResult = response.data;
          })
    },

    trackActivity() {
      axios.get('/api/v2/trackactivity/track')
          .then(() => {

          })
    },


    whichPortal(payload) {
      // if(payload.indexOf('casa.it') > 0)
      // {
      //   return 'casa.it';
      // }
      // if(payload.indexOf('immobiliare.it') > 0)
      // {
      //   return 'immobiliare.it';
      // }
      // if(payload.indexOf('idealista.it') > 0)
      // {
      //   return 'idealista.it';
      // }
      //
      // if(payload.indexOf('pisos.com') > 0)
      // {
      //   return 'pisos.com';
      // }
      //
      // if(payload.indexOf('fotocasa.es') > 0)
      // {
      //   return 'fotocasa.es';
      // }

      return "link";
    },
    isClone(data) {
      if (data == 1) {
        return 'abtg__td-isclone'
      }


    },
    getPriceMq(price, mq) {
      if (price !== undefined) {
        if (price.toString().includes(".")) {
          price = price.replace(".", "");
        }

        let v = Math.round(price / mq);
        return this.FORMAT_PRICE(v);
      }

    },

    showZoneName(z) {
      let zone = z.zone != null ? z.zone : "";
      let macrozone =
          z.macrozone != null ? (z.zone != null ? " - " : "") + z.macrozone : "";
      let microzone =
          z.microzone != null
              ? (z.macrozone != null ? " - " : "") + z.microzone
              : "";
      let wholeZone = zone + macrozone + microzone;
      if (wholeZone.length > 28) {
        return wholeZone.substr(0, 28) + "...";
      }
      return wholeZone;
    },

    showZoneNameHashtag(z) {
      let zone = z.zone != null ? z.zone : "";
      let macrozone =
          z.macrozone != null ? (z.zone != null ? " - " : "") + z.macrozone : "";
      let microzone =
          z.microzone != null
              ? (z.macrozone != null ? " - " : "") + z.microzone
              : "";
      let wholeZone = zone + macrozone + microzone;

      return wholeZone.replaceAll(" ", "");
    },

    showModal(modalName, type) {

      switch (type) {
        case 'new':
          this.localfolderName = '';
          break;
        case 'old':
          this.editFolder = true;
          break;
      }
      this.$modal.show(modalName);
    },

    setZoneToEdit(modalName) {
      this.$modal.show(modalName);
    },

    editBuilding(data) {
      this.SET_DATA({
        name: "formData",
        data: data,
      });
      this.showModal("m-building");
    },

    newBuilding() {
      this.clearForm();
      this.showModal("m-building");
    },

    closeModal(modalName) {
      this.SET_DATA({
        name: "idToDelete",
        data: null,
      });
      this.SET_DATA({
        name: "idZoneToDelete",
        data: null,
      });
      this.$modal.hide(modalName);
      this.editFolder = false;
    },

    retrieveMqRange(mqRange, customRange, index) {
      this.SET_DATA({
        name: "activateLoading",
        data: true,
      });
      mqRange =
          mqRange || mqRange === 0
              ? mqRange
              : customRange.min + "," + customRange.max;
      let payload = this.zoneInfo;
      payload.range = mqRange;
      this.buildingByZone({z: payload});
      this.tabOn({
        mqRange: mqRange,
        index: index,
      }); // tab active (custom included)
    },


    getComparabili(mqRange, customRange, index) {
      this.SET_DATA({
        name: "activateLoading",
        data: true,
      });
      mqRange = mqRange || mqRange === 0 ? mqRange : customRange.min + "," + customRange.max;
      let payload = this.zoneInfo;
      payload.range = mqRange;
      this.comparabili({z: payload});
      this.tabOn({
        mqRange: 444,
        index: index,
      }); // tab active (custom included)
    },

    setIdToDelete(id) {
      this.SET_DATA({
        name: "idToDelete",
        data: id,
      });
      this.showModal("m-delete");
    },
    setIdToNotClone(id) {
      this.SET_DATA({
        name: "idNotClone",
        data: id,
      });
      this.notClone();

    },
    setMapAndZoneToDelete(id) {
      this.SET_DATA({
        name: "idZoneToDelete",
        data: id,
      });
      this.showModal("m-delete");
    },

    deleteResource() {
      if (this.idZoneToDelete) {
        this.deleteZone(this.selectedZone);
      } else {
        this.deleteBuilding();
      }
    },

    updateMap() {
      // this.$router.push({path: '/mapping/search/' + this.zoneInfo.id + '/' + this.zoneInfo.region});
      window.location.href =
          "/mapping/search/" + this.zoneInfo.id + "/" + this.zoneInfo.region;
    },

    isThisLinkActive(payload) {
      if (this.activeAllZone) {
        return "";
      }
      if (
          this.zoneInfo &&
          this.zoneInfo.zone == payload.zone &&
          this.zoneInfo.macrozone == payload.macrozone &&
          this.zoneInfo.microzone == payload.microzone
      ) {
        return "abtg-zone-active";
      }
    },

    setMappingZone(payload) {
      this.zoneList.forEach((zone) => {
        if (zone.id === parseInt(payload.id)) {
          this.SET_DATA({
            name: "zoneInfo",
            data: zone,
          });
        }
      });
    },
    labelRenovation(payload) {
      switch (payload.renovated) {
        case 0:
          return "-";
        case 1:
          return "sì";
        case 2:
          return "no";
        case 3:
          return "ni";
      }
    },


    updateBuildingInline(building) {
      this.SET_DATA({
        name: "formData",
        data: building,
      });
      this.sendMappingData();
    },

    showAddressInput(id, focus) {
      let input = eval(`this.$refs.addressInput${id}`)[0];

      eval(`this.$refs.addressText${id}`)[0].classList.toggle("hidden");
      input.classList.toggle("hidden");

      if (focus) {
        input.focus();
      }
    },

    showFloorInput(id, focus) {
      let input = eval(`this.$refs.floorInput${id}`)[0];

      eval(`this.$refs.floorText${id}`)[0].classList.toggle("hidden");
      input.classList.toggle("hidden");

      if (focus) {
        input.focus();
      }
    },

    showRoomsInput(id, focus) {
      let input = eval(`this.$refs.roomsInput${id}`)[0];

      eval(`this.$refs.roomsText${id}`)[0].classList.toggle("hidden");
      input.classList.toggle("hidden");

      if (focus) {
        input.focus();
      }
    },

    showMqInput(id, focus) {
      let input = eval(`this.$refs.mqInput${id}`)[0];

      eval(`this.$refs.mqText${id}`)[0].classList.toggle("hidden");
      input.classList.toggle("hidden");

      if (focus) {
        input.focus();
      }
    },

    showPriceInput(id, focus) {
      let input = eval(`this.$refs.priceInput${id}`)[0];

      eval(`this.$refs.priceText${id}`)[0].classList.toggle("hidden");
      input.classList.toggle("hidden");

      if (focus) {
        input.focus();
      }
    },

    showRenovatedSelection(building) {
      this.SET_DATA({
        name: "formData",
        data: building,
      });

      let list = Object.entries(this.$refs).filter((item, index) => {
        if (/^renovated/.test(item[0])) {
          return item;
        }
      });

      if (list && list.length > 0) {
        list.forEach((item) => {
          if (item.length > 0 && item[0].includes(building.id.toString())) {
            return;
          }

          if (
              item.length > 0 &&
              item[0].includes("Text") &&
              item[1] &&
              item[1].length > 0
          ) {
            item[1][0].classList.remove("hidden");
          }

          if (
              item.length > 0 &&
              item[0].includes("Selection") &&
              item[1] &&
              item[1].length > 0
          ) {
            item[1][0].classList.add("hidden");
          }
        });
      }

      eval(`this.$refs.renovatedText${building.id}`)[0].classList.toggle(
          "hidden"
      );
      eval(`this.$refs.renovatedSelection${building.id}`)[0].classList.toggle(
          "hidden"
      );
    },

    showPencilIcon(target) {
      target.parentElement
          .getElementsByClassName("fa-pencil-alt")[0]
          .classList.toggle("hidden");
    },

    checkIfHasExist() {
      if (this.$route.hash) {
        let element = document.getElementById(
            `${this.$route.hash.replaceAll("%20", "").replace("#", "")}`
        );
        element ? element.click() : null;
      }
    },

    removeAllSelectedZones() {
      [...document.getElementsByClassName("abtg-zone-selected")].forEach(
          (zone) => {
            zone.classList.remove("abtg-zone-selected");
          }
      );
    },

    goToUrl(folderid) {

      window.location.href = `/mapping/?cityId=${this.selectedZone.cityId}&city=${this.selectedZone.city}&folderId=${folderid}`;


    },

    handleUrl(what) {
      let url = new URL(window.location.href);
      return url.searchParams.get(what);
    },

    changeZoneByUrl() {
      if (this.handleUrl('city') !== null && this.handleUrl('cityId') !== null) {
        if (this.handleUrl('folderId') !== null) {
          this.localfolderId = this.handleUrl('folderId');
        }
        this.selectedZone.city = this.handleUrl('city');
        this.selectedZone.cityId = this.handleUrl('cityId');
        this.zoneByCity({
          city: this.handleUrl('city'),
          cityId: this.handleUrl('cityId'),
          folderId: this.localfolderId = this.handleUrl('folderId')
        });
        setTimeout(() => {
          if (this.localfolderId !== '0' && this.allFolder) {
            this.allFolder.forEach((folder) => {
              if (this.localfolderId == folder.id) {
                this.localfolderName = folder.name;
              }
            });
          }


        }, 1500)
      }

    },


    createFolder(payload) {
      if (this.editFolder) {
        this.SET_DATA({
          name: "folderName",
          data: payload,
        },);
        this.SET_DATA({
          name: "folderId",
          data: this.localfolderId,
        },);
        this.saveFolder();
      } else {
        this.SET_DATA({
          name: "folderName",
          data: payload,
        },);
        this.SET_DATA({
          name: "checkedZones",
          data: this.zoneChecked,
        },);

        this.SET_DATA({
          name: "folderId",
          data: null,
        },);
        this.saveFolder();
      }


    },

    changeFolderlocal(id) {

      this.SET_DATA({
        name: "checkedZones",
        data: this.zoneChecked,
      },);
      this.SET_DATA({
        name: "folderId",
        data: id,
      },);
      this.changeFolder();
    },

    setFolderForDelete() {
      this.SET_DATA({
        name: "folderId",
        data: this.localfolderId,
      },);

      this.deleteFolder();


    },


  },
};
</script>

